// extracted by mini-css-extract-plugin
export var footer = "_qt-5";
export var fulfillmentInput = "_qt-0";
export var shipDateInput = "_qt-1";
export var shipmentModal = "_qt-2";
export var shipmentModalContent = "_qt-3";
export var tableContainer = "_qt-4";